/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountUpdateDataModel } from './AccountUpdateDataModel';
import {
    AccountUpdateDataModelFromJSON,
    AccountUpdateDataModelFromJSONTyped,
    AccountUpdateDataModelToJSON,
    AccountUpdateDataModelToJSONTyped,
} from './AccountUpdateDataModel';
import type { UpdateGroup } from './UpdateGroup';
import {
    UpdateGroupFromJSON,
    UpdateGroupFromJSONTyped,
    UpdateGroupToJSON,
    UpdateGroupToJSONTyped,
} from './UpdateGroup';

/**
 * 
 * @export
 * @interface AccountImportList
 */
export interface AccountImportList {
    /**
     * 
     * @type {boolean}
     * @memberof AccountImportList
     */
    addNewAccounts: boolean;
    /**
     * 
     * @type {Array<UpdateGroup>}
     * @memberof AccountImportList
     */
    updateGroups: Array<UpdateGroup>;
    /**
     * 
     * @type {Array<AccountUpdateDataModel>}
     * @memberof AccountImportList
     */
    accounts: Array<AccountUpdateDataModel>;
}

/**
 * Check if a given object implements the AccountImportList interface.
 */
export function instanceOfAccountImportList(value: object): value is AccountImportList {
    if (!('addNewAccounts' in value) || value['addNewAccounts'] === undefined) return false;
    if (!('updateGroups' in value) || value['updateGroups'] === undefined) return false;
    if (!('accounts' in value) || value['accounts'] === undefined) return false;
    return true;
}

export function AccountImportListFromJSON(json: any): AccountImportList {
    return AccountImportListFromJSONTyped(json, false);
}

export function AccountImportListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountImportList {
    if (json == null) {
        return json;
    }
    return {
        
        'addNewAccounts': json['addNewAccounts'],
        'updateGroups': ((json['updateGroups'] as Array<any>).map(UpdateGroupFromJSON)),
        'accounts': ((json['accounts'] as Array<any>).map(AccountUpdateDataModelFromJSON)),
    };
}

export function AccountImportListToJSON(json: any): AccountImportList {
    return AccountImportListToJSONTyped(json, false);
}

export function AccountImportListToJSONTyped(value?: AccountImportList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addNewAccounts': value['addNewAccounts'],
        'updateGroups': ((value['updateGroups'] as Array<any>).map(UpdateGroupToJSON)),
        'accounts': ((value['accounts'] as Array<any>).map(AccountUpdateDataModelToJSON)),
    };
}

